import Script from 'next/script'

import { env } from '@/shared/config'

export function SsoAuthCookieScript() {
    if (!env.SSO_OAUTH_COOKIE) {
        return null
    }

    return (
        <Script id="ssoauth" strategy="beforeInteractive">
            {`document.cookie = 'ssoauth=${env.SSO_OAUTH_COOKIE}; path=/'`}
        </Script>
    )
}
